import { Route } from "@angular/router";

import { GoLoginPageComponent } from "./go-login.component";

export const routes: Route[] = [
  {
    path: "go-login",
    component: GoLoginPageComponent
  }
];
